const permissao = {
  VIEW_CAIXA_DE_ENTRADA: 'VIEW_CAIXA_DE_ENTRADA',
  VIEW_EM_ANALISE: 'VIEW_EM_ANALISE'
}

export default permissao



// WEBPACK FOOTER //
// ./src/utils/permissao.js